import { render, staticRenderFns } from "./editText.vue?vue&type=template&id=6bff404e&"
import script from "./editText.vue?vue&type=script&lang=js&"
export * from "./editText.vue?vue&type=script&lang=js&"
import style0 from "./editText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports